import { render, staticRenderFns } from "./slider-fastvaluedeal-01.vue?vue&type=template&id=42f74422&scoped=true&"
import script from "./slider-fastvaluedeal-01.vue?vue&type=script&lang=js&"
export * from "./slider-fastvaluedeal-01.vue?vue&type=script&lang=js&"
import style0 from "./slider-fastvaluedeal-01.vue?vue&type=style&index=0&id=42f74422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f74422",
  null
  
)

export default component.exports